import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableList, TableListProvider, Typography } from 'seagull';
import { AddServicesButton } from '~/components/AddServicesButton/AddServicesButton';
import { useLocaleKeys } from '~/i18n';
import { AgreementDataModel } from '~/models';
import { getServicesTableDefs } from '../EditDraftsTable.utils';
import EditPackageNameButton from '../serviceCells/EditPackageNameButton';
import styles from './EditDraftService.module.scss';
import EditDraftServiceRow from './EditDraftServiceRow';
const getServicesByBundle = (draft)=>{
    const services = draft.services();
    const standaloneServices = services.length > 0 ? [
        {
            packageName: null,
            services,
            packageId: null
        }
    ] : [];
    const bundledServices = draft.serviceBundles().map((bundle)=>({
            packageName: bundle.name,
            packageId: bundle.id,
            services: bundle.services
        }));
    return [
        ...standaloneServices,
        ...bundledServices
    ];
};
export default function EditDraftServiceTable(param) {
    let { draft, onOpenModal, onAddServices } = param;
    const { t: draftTexts } = useLocaleKeys('pages.draftsDashboard');
    const servicesTableDefs = getServicesTableDefs();
    const servicesByBundle = getServicesByBundle(draft);
    const isDisabled = draft.isScheduled();
    const disabledTooltip = isDisabled ? 'In order to edit a scheduled proposal, its scheduling must be canceled.' : undefined;
    function renderAddServicesButton(param) {
        let { packageId } = param;
        return /*#__PURE__*/ _jsx(AddServicesButton, {
            className: styles.addServicesButton,
            variant: "textWithIcon",
            popoverHorizontalAlign: "left",
            agreementData: AgreementDataModel.fromDraft(draft),
            disabled: isDisabled,
            testId: "add-services-".concat(packageId || draft.id()),
            onServicesAdded: (services)=>onAddServices(services, packageId)
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        children: servicesByBundle.length > 0 ? servicesByBundle.map((param, bundleIndex)=>{
            let { packageName, packageId, services } = param;
            return /*#__PURE__*/ _jsxs("div", {
                className: styles.bundleTable,
                children: [
                    packageId && /*#__PURE__*/ _jsxs("div", {
                        className: styles.bundleHeader,
                        "data-testid": "bundle-header-".concat(packageId),
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: "package-name-".concat(packageId),
                                children: packageName
                            }),
                            /*#__PURE__*/ _jsx(EditPackageNameButton, {
                                packageName: packageName,
                                draft: draft,
                                packageId: packageId,
                                onOpenModal: onOpenModal
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(TableListProvider, {
                        columnDefs: servicesTableDefs,
                        hasActionColumn: true,
                        children: [
                            /*#__PURE__*/ _jsx(TableList.Header, {
                                items: servicesTableDefs
                            }),
                            services.length > 0 && services.map((service, index)=>/*#__PURE__*/ _jsx(EditDraftServiceRow, {
                                    service: service,
                                    packageId: packageId,
                                    index: index,
                                    draft: draft,
                                    onOpenModal: onOpenModal,
                                    isDisabled: isDisabled,
                                    disabledTooltip: disabledTooltip
                                }, service.id)),
                            services.length === 0 && packageId && /*#__PURE__*/ _jsx("div", {
                                className: styles.noServices,
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    children: draftTexts.noServicesInPackage()
                                })
                            }),
                            renderAddServicesButton({
                                packageId
                            })
                        ]
                    })
                ]
            }, packageId || "standalone-".concat(bundleIndex));
        }) : renderAddServicesButton({
            packageId: null
        })
    });
}
